import { ShowWhen } from '@/components'
import { Button } from '@surein/ui'
import { ArrowRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { SuccessContainer } from '../styles'

interface Messages {
  title: string
  subtitle: string
  buttonText: string
  modalContents: Record<string, unknown>
}

const useMessages = (): Messages => {
  const { t } = useTranslation()

  return {
    title: t('order_success_title'),
    subtitle: t('checkout.subtitles.success'),
    buttonText: t('back_to_dashboard'),
    modalContents: t('checkout.upsellModalContent', { returnObjects: true }),
  }
}

interface SuccessOrderStepBaseProps {
  onFinish?: () => void
}

export const SuccessOrderStepBase = ({
  onFinish,
}: SuccessOrderStepBaseProps) => {
  const messages = useMessages()

  return (
    <SuccessContainer>
      <ShowWhen when={Boolean(onFinish)}>
        <Button
          suffixIcon={ArrowRight}
          onClick={onFinish}
          variant="primary"
          shape="square"
        >
          {messages.buttonText}
        </Button>
      </ShowWhen>
    </SuccessContainer>
  )
}
